import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";

import "core-js";
import "core-js/fn/string/includes";
import "core-js/es7/array";
import "core-js/es6/symbol";
import "core-js/fn/symbol/iterator.js";
import "url-search-params-polyfill";
import "custom-event-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import "antd/dist/antd.css";
import "antd/dist/antd.css";
import smoothscroll from "smoothscroll-polyfill";
import "bootstrap/dist/css/bootstrap.css";

import configureStore from "./config-store";
import "./helper/interceptor";
import App from "./App";
import "./styles/base.scss";
import "./App.scss";
// import './server';

smoothscroll.polyfill();

/************ store configration *********/
const { store } = configureStore();

const routing = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(routing, document.getElementById("root"));
